import React from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import ClubInfoSteps from "../../components/auth/ClubInfoSteps";
import ClubInfoForm3 from "../../components/auth/ClubInfoForm3";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const ClubInfo3 = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  return (
    <AuthLayout>
      <div className="  flex flex-col gap-8 px-12">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title={Auth?.club_info_3.club_info_3_title} />
        </div>
        <ClubInfoSteps
          servicesActive={true}
          courtsActive={true}
          hoursBold={true}
          servicesBold={true}
          courtsBold={true}
        />

        <ClubInfoForm3 />
      </div>
    </AuthLayout>
  );
};

export default ClubInfo3;
